<template>
  <intersect @enter="animate = true" :threshold="[0, 0.25, 0.5, 0.75, 1]">
    <div
      class="smart-buttons mt-34 fadeUp"
      :class="animate ? 'animate' : ''"
      v-if="_.size(itemData)"
    >
      <template v-for="item in itemData">
        <a v-if="item.slug === 'mobile'" :href="`tel:${item.url.trim().replaceAll(' ', '')}`" class="smart-button-item">
          <div class="smart-button-icon" v-html="item.svg"></div>

          <div class="smart-button-text">
            <span class="smart-button-label">
              {{ item.title }}
            </span>

            <span class="smart-button-title">
              {{ item.hover_title }}
            </span>
          </div>
        </a>

        <a v-else :href="item.url" :target="item.targetblank ? '_blank' : '_self'" class="smart-button-item">
          <div class="smart-button-icon" v-html="item.svg"></div>

          <div class="smart-button-text">
            <span class="smart-button-label">
              {{ item.title }}
            </span>

            <span class="smart-button-title">
              {{ item.hover_title }}
            </span>
          </div>
        </a>
      </template> 
    </div>
  </intersect>
</template>

<script>
import Intersect from "vue-intersect";
export default {
  props: {
    itemData: {
      type: Array,
    },
  },
  components: { Intersect },
  data() {
    return {
      animate: false,
    };
  },
};
</script>

<style>
.smart-buttons {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  grid-gap: 20px;
  margin-bottom: 55px;
}

.smart-button-item {
  display: flex;
  align-items: center;
  background-color: rgba(188, 190, 192, 0.2);
  padding: 20px;
  border-radius: 4px;
  gap: 20px;
}

.smart-button-icon {
  flex: 40px 0 0;
  height: 40px;
}

.smart-button-icon svg {
  width: 100%;
  height: 100%;
}

.smart-button-text {
  display: flex;
  flex-direction: column;
}

.smart-button-label {
  font-size: 13px;
  color: rgba(158, 158, 158, 1);
}

.smart-button-title {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
  font-size: 16px;
  color: #444958;
  word-break: break-word;
}

@media (max-width: 1023px) {
  .smart-buttons {
    margin-bottom: 34px;
  }
}

@media (max-width: 767px) {
  .smart-buttons {
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }
}
</style>
